import React from "react";
import "./IntroTab.scss";
import lottie from "../../../../../assets/lottie/virus.json";
import { Button } from "../../../../../components/Button/Button";
import { useGameState } from "../../../../../hooks/useGameState";
import { useTranslation } from "react-i18next";
import { Player } from "@lottiefiles/react-lottie-player";

interface IProps {

}

export function IntroTab(props: IProps) {
    const { setGameState } = useGameState();
    const { t } = useTranslation();
    return (
        <div className="intro-tab-wrapper">
            {/*<img src={virusImage} />*/}
            <Player
                autoplay
                loop
                src={lottie}
                style={{ width: '100%', height: '100%'}}
            ></Player>
            {/* eslint-disable-next-line react/jsx-no-comment-textnodes */}
            <h3>{t('game.identification')} /////</h3>
            <h2>[type 2344569-22]</h2>
            <Button variant={'major-alpha'} icon={'arrow-right'} onClick={() => setGameState('tutorial')}>
                {t('game.button-assign-this-research')}
            </Button>
        </div>
    )
}
